import React from "react";
import HeroSection from "../components/AboutUs/HeroSection";
import Features from "../components/AboutUs/Features";
import PaymentOptions from "../components/AboutUs/PaymentOptions";
import Values from "../components/AboutUs/Values";
import Last from "../components/AboutUs/Last";
import Banner from "../components/ContactUs/Banner";
const AboutUs = () => {
  return (
    <div>
      <Banner
        header="About Us"
        text="Compare prices, order and buy mobile phones, electronics,
              appliances, and accessories online for hassle-free delivery to
              your home."
      />
      <Features />
      <Values />
      <PaymentOptions />
    </div>
  );
};

export default AboutUs;
